import { IconSize } from "../theme";
import { IconProps } from "../theme";

const Scales: React.FC<IconProps> = ({ size = IconSize.M }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Scales">
        <path
          id="Vector"
          d="M16.8349 9.5498L14.5849 3.9248C14.5429 3.82078 14.4706 3.73172 14.3775 3.66907C14.2844 3.60642 14.1747 3.57305 14.0625 3.57324C14.0216 3.57387 13.9808 3.57882 13.9409 3.58801L9.56251 4.55762V3.01074C9.56251 2.86156 9.50325 2.71848 9.39776 2.61299C9.29227 2.50751 9.1492 2.44824 9.00001 2.44824C8.85083 2.44824 8.70775 2.50751 8.60226 2.61299C8.49677 2.71848 8.43751 2.86156 8.43751 3.01074V4.80934L3.81587 5.83801C3.72677 5.85745 3.64373 5.89827 3.57391 5.95694C3.50409 6.01561 3.44959 6.09038 3.41509 6.1748L1.16509 11.7998C1.13817 11.8669 1.12456 11.9385 1.12501 12.0107C1.12501 13.6497 2.85048 14.2607 3.93751 14.2607C5.02454 14.2607 6.75001 13.6497 6.75001 12.0107C6.75046 11.9385 6.73685 11.8669 6.70993 11.7998L4.70532 6.79145L8.43751 5.96387V14.8232H7.31251C7.16333 14.8232 7.02025 14.8825 6.91476 14.988C6.80927 15.0935 6.75001 15.2366 6.75001 15.3857C6.75001 15.5349 6.80927 15.678 6.91476 15.7835C7.02025 15.889 7.16333 15.9482 7.31251 15.9482H10.6875C10.8367 15.9482 10.9798 15.889 11.0853 15.7835C11.1907 15.678 11.25 15.5349 11.25 15.3857C11.25 15.2366 11.1907 15.0935 11.0853 14.988C10.9798 14.8825 10.8367 14.8232 10.6875 14.8232H9.56251V5.71215L13.1484 4.91621L11.2901 9.5498C11.2632 9.61685 11.2496 9.6885 11.25 9.76074C11.25 11.3997 12.9755 12.0107 14.0625 12.0107C15.1495 12.0107 16.875 11.3997 16.875 9.76074C16.8755 9.6885 16.8618 9.61685 16.8349 9.5498ZM5.58493 12.0107H2.2936L3.93751 7.90027L5.58493 12.0107ZM12.4221 9.76074L14.0625 5.65027L15.7064 9.76074H12.4221Z"
          fill="#071443"
        />
      </g>
    </svg>
  );
};

export default Scales;
